import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {PortvisitUtils} from "../../../../../refdata/portvisit-utils";
import {HarbourDuesDeclaration} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
  selector: 'app-harbour-dues-admin',
  templateUrl: './harbour-dues-admin.component.html',
  styleUrls: ['./harbour-dues-admin.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HarbourDuesAdminComponent {
  declaration = input<HarbourDuesDeclaration>();

  toOutgoingMessages() {
    let businessCorrelationId = this.declaration().crn + "_HarbourDues_" + this.declaration().statementNumber;
    PortvisitUtils.redirectToMessageManagement(businessCorrelationId);
  }
}
